"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var enquiryFormStyles = makeStyles_1.default(function (_a) {
    var _b, _c, _d;
    var palette = _a.palette, breakpoints = _a.breakpoints, spacing = _a.spacing;
    return ({
        formWrapper: (_b = {
                backgroundColor: function (_a) {
                    var isCheckout4Enabled = _a.isCheckout4Enabled;
                    return !!isCheckout4Enabled ? 'transparent' : palette.background.alternate;
                },
                padding: function (_a) {
                    var isCheckout4Enabled = _a.isCheckout4Enabled;
                    return (!!isCheckout4Enabled ? '0' : spacing(2) + " " + spacing(5));
                },
                '& form': {
                    maxWidth: '100%',
                },
                '& .form-group.field.field-string.field-error.has-error.has-danger ul li': {
                    display: 'none',
                },
                '& .error-detail': {
                    display: 'none',
                },
                '& .form-group.field-object': {
                    '& .form-group.field-object .form-group.field-object, & .form-group.field-string, & .form-group.field-integer': {
                        marginBottom: 10,
                    },
                    '& .form-group.field-object .field': (_c = {},
                        _c[breakpoints.down('sm')] = {
                            paddingBottom: 20,
                        },
                        _c),
                }
            },
            _b[breakpoints.down('sm')] = {
                padding: function () { return "0 " + spacing(1.5); },
            },
            _b),
        myAccountIntegrationContainer: {
            position: 'relative',
        },
        signinButton: (_d = {
                position: 'absolute',
                top: '-55px',
                right: 0
            },
            _d[breakpoints.down('xs')] = {
                position: 'relative',
                top: 0,
            },
            _d),
    });
}, { name: 'GqlCheckout_EnquiryForm' });
exports.default = enquiryFormStyles;
